export default __webpack_public_path__ + "static/media/me.87b5f5c7.jpg";